export default __webpack_public_path__ + "static/media/quote.87e2bfcf.svg";